import React from 'react';

/**
 * Small pulsating hourglass emblem for inline button use.
 * Replaces the lucide <Hourglass> icon during generation.
 */
const HourglassIcon = ({ className = 'w-4 h-4', style = {} }) => (
  <img
    src={`${process.env.PUBLIC_URL}/hourglass_emblem_transparent.png`}
    alt=""
    className={className}
    style={{
      objectFit: 'contain',
      animation: 'hgPulse 2s ease-in-out infinite',
      ...style,
    }}
  />
);

export default HourglassIcon;
